import { Box, Stack } from '@mui/material'
import custom from '../../styles/mui/szVariables.json'

export default function TouBars({ content }: any) {
    const noData  = content.offPeak===0 && 
                    content.shoulder===0 && 
                    content.peak===0
    return (
        <Box height="16px" width="100%"
            sx={{
                backgroundColor: noData?'sz.colors.gray100': 'inherit',
                borderRadius: custom.corners2,
            }}>
            <Stack direction="row" 
                justifyContent={"center"}
                width="100%"
                spacing={custom.spacing.xxxxs}> 
                {content.offPeak>0 && 
                    <Box height="16px" 
                        width={`${content.offPeak>0?content.offPeak:0}%`}
                        mb={custom.spacing.xxs}
                        sx={{ 
                            backgroundColor: 'sz.colors.orange200',
                            borderRadius: custom.corners2,
                        }} /> 
                }
                {content.shoulder>0 &&
                    <Box height="16px" 
                        width={`${content.shoulder}%`}  
                        mb={custom.spacing.xxs} 
                        sx={{ 
                            backgroundColor: 'sz.colors.orange300',
                            borderRadius: custom.corners2,
                        }} /> 
                }
                {content.peak>0 &&
                    <Box height="16px" 
                        width={`${content.peak}%`} 
                        mb={custom.spacing.xxs}  
                        sx={{ 
                            backgroundColor: 'sz.colors.orange400',
                            borderRadius: custom.corners2,
                        }} /> 
                }
            </Stack>
        </Box>   
    )
}